module.exports = __webpack_public_path__ + "img/5.05.fd8faaeb.jpg";